import { LocationQuery } from 'vue-router';
import { CommuterTrafficFeeService } from './commuter-traffic-fee.service';
const service = new CommuterTrafficFeeService();

interface CommuterTrafficFeeState {}

const state: CommuterTrafficFeeState = {};

const getters = {};

const mutations = {};

const actions = {
   async getCommuterTrafficFees(context: any, query: LocationQuery) {
      return await service.getCommuterTrafficFees(query);
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
